import { api } from '@/services/api';
import { UserDto } from '@repo/common-types';

export const me = async () => await api.get<UserDto>(`/v1/auth/me`);
